module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-page"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_vm._t("header", [_c('div', {
    staticClass: "sample-content"
  }, [_vm._l((50), function(n) {
    return [_vm._v("Header ")]
  })], 2)])], 2), _vm._v(" "), _c('div', [_c('v-navigation-drawer', {
    attrs: {
      "mobile-break-point": 800
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-title', {
    staticClass: "title"
  }, [_vm._v("\n                Application\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-list-item', {
      key: item.title,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    style: (_vm.contentStyle)
  }, _vm._l((_vm.columnList), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "layout-column",
      style: ({
        'flex-basis': column.width
      }),
      attrs: {
        "id": 'col' + (index + 1)
      }
    }, [_c('div', {
      staticClass: "layout-column-padder"
    }, [_vm._t('col' + (index + 1), [_c('div', {
      staticClass: "sample-content"
    }, [_vm._l((400), function(n) {
      return [_vm._v("Column " + _vm._s(index) + " ")]
    })], 2)])], 2)])
  }), 0)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._t("footer", [(_vm.isMichelle) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "10px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "color": "grey lighten-2",
      "large": ""
    }
  }, [_vm._v("sentiment_satisfied_alt")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "15px"
    }
  })])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dialogs"
    }
  }, [_vm._t("dialogs")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74cbb23a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LayoutContainer2.vue
// module id = 2606
// module chunks = 1